import { Directive, inject, Type, ViewContainerRef } from '@angular/core';
import { OverlaysService } from '../overlays';


@Directive({
    selector: '[modalsTarget]',
    providers: [
        OverlaysService,
    ]
})
export class ModalsTarget {

    private overlaysService = inject(OverlaysService);

    private vcr = inject(ViewContainerRef);

    constructor() {
        this.overlaysService.overlaysHostRef = this.vcr;
    }

    openModal<T>(modalComponent: Type<T>, inputs?: Partial<T> | Record<string, unknown>) {
        return this.overlaysService.createOverlay(modalComponent, { inputs });
    }
}
